<template>
  <div class="flex flex-col description-list__item">
    <dt class="text-sm font-medium">
      <slot name="title" />
    </dt>
    <dd class="whitespace-nowrap">
      <slot />
    </dd>
  </div>
</template>
